// src/hooks/useDebounce.js
import { useState, useEffect } from 'react';

/**
 * useDebounce
 * Gibt den aktuellen Wert `value` erst nach `delay` Millisekunden zurück,
 * nachdem `value` zuletzt geändert wurde.
 * So kann man z. B. Suchanfragen debouncen und vermeidet unnötige Neuberechnungen.
 *
 * @param {any} value   Der zu debouncende Wert
 * @param {number} delay Verzögerung in ms (Standard 300)
 * @returns {any} debouncedValue
 */
export function useDebounce(value, delay = 300) {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
}
